function checkExerciseAnswers(diagram_id, submit_btn, next_btn) {
  var textarea = document.querySelectorAll('#' + diagram_id + ' .answer-field')[0];
  var answer = document.querySelectorAll('#' + diagram_id + ' .hint')[0];
  var next_button = document.getElementById(next_btn);


  if (textarea.value) {
    textarea.disabled = true;
    answer.style = 'opacity: 1;';
    submit_btn.style = 'display: none;';
    next_button.style = 'display: inline-block; opacity: 1;';
  } else textarea.focus();
}

function submit(diagram_id, submit_btn, next_btn) {
  var action_button = document.getElementById(submit_btn);

  action_button.addEventListener('click', function (el) {
    checkExerciseAnswers(diagram_id, el.srcElement, next_btn);
  });
}

export default function submitAction(diagram_id, submit_btn, next_btn) {
  submit(diagram_id, submit_btn, next_btn);
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a2/diagram_logic.js